/* @flow */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import entities from './entities'
import notifications from './notifications'
import session from './session'
import ui from './ui'
import devicehq from '@/devicehq/store/devicehq_modules'
import lensmodules from '@/modules/storeModules'
import corporations from '@/modules/systemStates/store/corporations'
import lens_sites from '@/modules/systemStates/store/lens_sites'
import tenant_accounts from '@/modules/systemStates/store/tenant_accounts'

import service_api_keys from './service_api_keys'

Vue.use(Vuex)

export const SET_UNSAVED_CHANGES_TRUE = 'SET_UNSAVED_CHANGES_TRUE'
export const SET_UNSAVED_CHANGES_FALSE = 'SET_UNSAVED_CHANGES_FALSE'

const productionOnlyPlugins =
  process.env.NODE_ENV === 'test'
    ? []
    : [
        createPersistedState({
          paths: [
            'session',
            'ui',
            'entities.application_networks.statistics',
            'entities.end_devices.statistics',
            'entities.device_groups.statistics',
            'entities.device_profiles.statistics',
            'entities.policies.statistics',
            'entities.gateways.statistics',
            'entities.organizations',
            'entities.service_api_keys.statistics',
          ],
        }),
      ]

const initialState = () => ({
  unsavedChanges: false,
})

// strict mode not recommended for production:
// https://vuex.vuejs.org/guide/strict.html

export default new Vuex.Store({
  strict: (process.env.NODE_ENV !== 'production'),
  plugins: [...productionOnlyPlugins],
  modules: {
    entities,
    notifications,
    session,
    ui,
    devicehq,
    lensmodules,
    corporations,
    lens_sites,
    service_api_keys,
    tenant_accounts,
  },
  state: initialState(),
  getters: {},
  mutations: {
    RESET_STATE(state: Object) {
      Object.assign(state, initialState())
    },
    [SET_UNSAVED_CHANGES_TRUE](state: Object) {
      state.unsavedChanges = true
    },
    [SET_UNSAVED_CHANGES_FALSE](state: Object) {
      state.unsavedChanges = false
    },
  },
  actions: {},
})

export type JsonApiEntity = {
  attributes?: {
    application_network_id?: string,
    device_profile_id?: string,
    organization_id?: string,
  },
  relationships?: Object,
  meta?: Object,
  suppressNotifications?: boolean,
  organization_id?: string,
}



// WEBPACK FOOTER //
// ./src/store/index.js